import { NNBSP } from './char';
export const THOUSAND_DELIMITER = NNBSP;
export const FRACTIONAL_DELIMITER = ',';